export default __webpack_public_path__ + "static/media/EM0720.34I-22031_-15021_0.33e6b41e.jpg";